// extracted by mini-css-extract-plugin
export default {"inputError":"CreateProducts_inputError__9hQoP","exito":"CreateProducts_exito__nHw5x","createProductName":"CreateProducts_createProductName__k-YN4"};